import { render, staticRenderFns } from "./ExamsCreate.vue?vue&type=template&id=022181b4&"
import script from "./ExamsCreate.vue?vue&type=script&lang=js&"
export * from "./ExamsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports